import { Regex } from "../../../../../../../../constant/Regex"

const { REGEX_HALF_SIZE_PROJECT_NAME } = Regex

export const checkIsHalfSize = (value: string) =>
  !!REGEX_HALF_SIZE_PROJECT_NAME.exec(value)
